import styled from 'styled-components';

export const StyledCloseButton = styled.button`
  appearance: none;
  background: transparent;
  border: 0;
  margin: 0;
  padding: 0;
  cursor: pointer;
  position: absolute;
  font-size: 1rem;
  top: 0.5em;
  right: 0.5em;
`;
